/*
 ** Custom fumction for submissions form validation
 ** Created by @ahmad.gharaibeh@brande.ue
 */
var lastScrollTop, // This Varibale will store the top position
  navbar = document.querySelector("nav.navbar");

window.addEventListener("scroll", function () {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  scrollTop > 100
    ? navbar.classList.add("sticky")
    : navbar.classList.remove("sticky");

  // lastScrollTop = scrollTop; //New Position Stored
});

/*
 ** hiddin html, body scrolling
 ** Created by @ahmad.gharaibeh@brande.ue
 */
const hideScrol = () => {
  let body = document.querySelector("html");
  let html = document.querySelector("body");

  html.classList.toggle("hideScroll");
  body.classList.toggle("hideScroll");
};

/*
 ** Open and close mobile menue and disable scrolling
 ** Created by @ahmad.gharaibeh@brande.ue
 */
const btnToggler = document.querySelector(".navbar-toggle"),
  btnCloseAside = document.querySelector(".close-aside"),
  asidOverlay = document.querySelector(".aside-overlay"),
  aside = document.querySelector("nav.aside");

const asideBehavior = () => {
  aside.classList.toggle("show");
  btnToggler.classList.toggle("open");
  asidOverlay.classList.toggle("show");
  hideScrol();
};

btnToggler.addEventListener("click", (event) => {
  asideBehavior();
});

btnCloseAside.addEventListener("click", (event) => {
  asideBehavior();
});

asidOverlay.addEventListener("click", (event) => {
  asideBehavior();
});

/*
 ** Function for listing value of items in Aside
 ** Created by @ahmad.gharaibeh@brande.ue
 */

// const listMenuItem = document.querySelector(".navbar-nav").childElementCount;
// const menuItem = document.querySelector(".navbar-nav").childNodes('li');
// for ( var i = 0; i <= listMenuItem; i++ ) {

// }

/*
 ** Appear and view submenue items
 ** Created by @ahmad.gharaibeh@brande.ue
 */
const DropdownMenue = document.querySelector(".menu-item-has-children");
DropdownMenue
  ? DropdownMenue.addEventListener("click", (event) => {
      DropdownMenue.classList.toggle("open");
    })
  : null;

export const Navbar = [];
